import { DatePipe } from '@angular/common';
import { Component, effect, inject, input, signal } from '@angular/core';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { INormalIOExtenderList } from '../../../../../models/io-extender';
import { Functions } from '../../../../../services/shared/functions';
import { IconsStyles } from '../../../../../services/shared/icons-styles';

@Component({
  selector: 'app-normal-io',
  imports: [TableModule, CardModule, DatePipe],
  templateUrl: './normal-io.html',
  styleUrl: './normal-io.css',
})
export class NormalIo {
  normalExtenders = input.required<INormalIOExtenderList>();
  columns = signal<string[]>([]);
  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);

  constructor() {
    effect(() => {
      this.columns.set([]);
      const normalIO = this.normalExtenders();
      if (!normalIO) {
        this.columns.set([]);
        return;
      }

      this.columns.update((values) => {
        return [...values, 'Place', 'Status'];
      });

      for (let i = 0; i < normalIO.digitalInputsAmount; i++) {
        this.columns.update((values) => {
          return [...values, `Input ${i + 1}`];
        });
      }

      for (let i = 0; i < normalIO.digitalOutputsAmount; i++) {
        this.columns.update((values) => {
          return [...values, `Output ${i + 1}`];
        });
      }

      for (let i = 0; i < normalIO.analogCurrentOutputsAmount; i++) {
        this.columns.update((values) => {
          return [...values, `Current output ${i + 1}`];
        });
      }

      for (let i = 0; i < normalIO.analogVoltageOutputsAmount; i++) {
        this.columns.update((values) => {
          return [...values, `Voltage output ${i + 1}`];
        });
      }

      this.columns.update((values) => {
        return [...values, 'Last Update'];
      });
    });
  }
}
